class ConvertNulls {

    public recurseObject(obj: any) {

        if (obj === null) {
            return undefined;

        } else if (typeof obj !== 'object') {
            return obj;

        } else {
        
        if (obj instanceof Array) {
            for (const key of obj) {
                this.recurseObject(key);
        }
        
        } else {
                for (const key in obj) {

                    if (obj[key] === null) {
                        obj[key] = '';
                    
                    } else if (typeof obj[key] === 'object') {
                        this.recurseObject(obj[key]);
                    }
                }
            }
        }

        return obj;
    }
}

export default ConvertNulls;


// WEBPACK FOOTER //
// ./src/Services/ConvertNulls/ConvertNulls.tsx